module.exports = __webpack_public_path__ + "static/epic-japan-7452184ee7e9fdcebe6b5c1d15f9c063.png";